import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import Cache from 'root/cache';
import Modals from 'root/modals';
import Util from 'root/module/util';
import Form from 'root/module/form';
import View from 'root/view/base';

const Trello_Send = View.extend({
    boards : null,
    fields : {},

    title    : '',
    board_id : '',
    list_id  : '',
    labels   : [],
    members  : [],

    form_value : {
        title: ''
    },

    events: {
        'click .dropdown-board li'               : 'onSelectBoard',
        'click .dropdown-list li'                : 'onSelectList',
        'click .dropdown-member li'              : 'onSelectMember',
        'click .dropdown-member .badge-btn .btn' : 'onRemoveMember',
        'click .dropdown-label li'               : 'onSelectLabel',
        'click .dropdown-label .badge-btn .btn'  : 'onRemoveLabel',
        'submit form'                            : 'onSubmit',
        'click .reconnect'                       : 'onReconnect'
    },

    dom_handlers: {
        onSelectBoard: function(e) {
            this.board_id = $(e.currentTarget).data('id');

            if (this.fields[this.board_id]) {
                if (this.fields[this.board_id].lists.length) {
                    this.list_id = this.fields[this.board_id].lists[0].id;
                } else {
                    this.list_id = '';
                }
            }

            this.labels  = [];
            this.members = [];

            this.renderBoards();
            this.renderLists();
            this.renderMembers();
            this.renderLabels();

            if (!this.fields[this.board_id]) {
                this.loadFields(this.board_id);
            }
        },

        onSelectList: function(e) {
            this.list_id = $(e.currentTarget).data('id') || '';
            this.renderLists();
        },

        onSelectMember: function(e) {
            var member = $(e.currentTarget).data('id');

            if (member) {
                this.members.push($(e.currentTarget).data('id'));
                this.renderMembers();
            }
        },

        onRemoveMember: function(e) {
            e.stopPropagation();

            var member = $(e.currentTarget).next('input:checkbox').val();
            this.members.splice(this.members.indexOf(member), 1);

            this.renderMembers();
        },

        onSelectLabel: function(e) {
            var label = $(e.currentTarget).data('id');

            if (label) {
                this.labels.push($(e.currentTarget).data('id'));
                this.renderLabels();
            }
        },

        onRemoveLabel: function(e) {
            e.stopPropagation();

            var label = $(e.currentTarget).next('input:checkbox').val();
            this.labels.splice(this.labels.indexOf(label), 1);

            this.renderLabels();
        },

        onSubmit: function(e) {
            var form_data = Form.getData(this.$el.find('form'));

            if (!this.list_id) {
                // empty board or list
                UI.error('Please select a List');
                return;
            }

            this.$el.find('button[type="submit"]').prop('disabled', true).addClass('loading');

            this.$el.find('.mask-light').show();
            this.$el.find('.progress-loader').width('0%').show();
            var progress = 0;
            var timeout = setInterval(function() {
                progress = Math.min(90, progress + Math.random() * 5);
                this.$el.find('.progress-loader').width(progress + '%');
            }.bind(this), 50);

            Cache.app.request({
                action: 'integration/sendFeedbackToTrello',
                context: this,
                data: _.extend(form_data, {
                    feedback_id : this.model.get('id'),
                    list_id     : this.list_id,
                    title       : form_data.title,
                    description : form_data.description,
                    members     : this.members,
                    labels      : this.labels,
                    due_date    : form_data.due_date
                }),
                success: function(response) {
                    this.model.set('trello_url', response.trello_url);

                    setTimeout(function() {
                        UI.success('Card created in Trello');
                        this.trigger('submit:success');
                    }.bind(this), 800);  // wait for animation to finish
                },
                complete: function() {
                    this.$el.find('button[type="submit"]').prop('disabled', false).removeClass('loading');

                    clearInterval(timeout);
                    this.$el.find('.progress-loader').width('100%');
                }
            });
        },

        onReconnect: function(e) {
            var connected_app = Cache.connected_app_trello.get(Cache.integration_trello.findWhere({project_id: this.model.get('project_id')})?.get('app_id') || 0);

            if (connected_app) {
                Modals.reconnectConnectedApp('trello', connected_app, () => {
                    Modals.sendToTrello(this.model.id);
                });
            } else {
                window.parent.location = '/account/connected_app';
            }
        }
    },

    initialize: function() {
        this.form_value  = {
            title: ''
        };

        if (this.model.isDesign() || this.model.isPdf() || this.model.isVideoUpload()) {
            this.title = 'Feedback for ' + this.model.get('page');
        } else {
            this.title = 'Feedback #' + Util.padLeft(this.model.id, '000000');
        }

        if (this.model.get('title')) {
            this.form_value.title = this.model.get('title');
        }

        this.fields  = {};

        this.board_id = Cache.integration_trello.findWhere({project_id: this.model.get('project_id')})?.get('board_id') | '';
        this.list_id  = Cache.integration_trello.findWhere({project_id: this.model.get('project_id')})?.get('list_id') | '';
        this.labels   = [];
        this.members  = [];
    },

    loadBoards: function() {
        var cache_key = 'trello_boards_' + Cache.integration_trello.findWhere({project_id: this.model.get('project_id')})?.get('board_id') || '';

        if (Cache.get(cache_key)) {
            this.loadBoardsSuccess(Cache.get(cache_key));
        } else {
            Cache.app.request({
                action: 'integration/loadSendOptions',
                data: {
                    type: 'trello',
                    project_id: this.model.get('project_id')
                },
                context: this,
                success: function(response) {
                    if (response.username) {
                        Cache.add(cache_key, response, false);
                        this.loadBoardsSuccess(response);
                    } else {
                        this.renderError();
                    }
                }
            });
        }
    },

    loadFields: function(board_id) {
        var cache_key = 'trello_fields_' + Cache.integration_trello.findWhere({project_id: this.model.get('project_id')})?.get('board_id') || '';

        if (Cache.get(cache_key)) {
            this.loadFieldsSuccess(Cache.get(cache_key), board_id);
        } else {
            Cache.app.request({
                action: 'integration/loadSendOptions',
                data: {
                    type: 'trello_fields',
                    project_id: this.model.get('project_id'),
                    board_id: board_id
                },
                context: this,
                success: function(response) {
                    Cache.add(cache_key, response, false);
                    this.loadFieldsSuccess(response, board_id);
                }
            });
        }
    },

    loadBoardsSuccess: function(response) {
        this.boards = response.boards;

        var board = this.searchBoard(this.board_id);
        if (!board) {
            this.board_id = this.boards.length ? this.boards[0].id : '';
        }

        this.render();
    },

    loadFieldsSuccess: function(response, board_id) {
        this.fields[board_id] = response;

        if (!this.searchList(board_id, this.list_id)) {
            if (this.fields[board_id].lists.length) {
                this.list_id = this.fields[board_id].lists[0].id;
            } else {
                this.list_id = '';
            }
        }

        this.renderLists();
        this.renderLabels();
        this.renderMembers();
    },

    searchBoard: function(board_id) {
        var result = false;

        if (this.boards) {
            this.boards.forEach(function(board) {
                if (board.id === board_id) {
                    result = board;
                }
            });
        }

        return result;
    },

    searchList: function(board_id, list_id) {
        var result = false;

        if (this.fields[board_id]) {
            this.fields[board_id].lists.forEach(function(list) {
                if (list.id === list_id) {
                    result = list;
                }
            });
        }

        return result;
    },

    searchMember: function(board_id, member_id) {
        var result = false;

        if (this.fields[board_id]) {
            this.fields[board_id].members.forEach(function(member) {
                if (member.id === member_id) {
                    result = member;
                }
            });
        }

        return result;
    },

    searchLabel: function(board_id, label_id) {
        var result = false;

        if (this.fields[board_id]) {
            this.fields[board_id].labels.forEach(function(label) {
                if (label.id === label_id) {
                    result = label;
                }
            });
        }

        return result;
    },

    searchMembers: function(board_id) {
        return this.fields[board_id] ? this.fields[board_id].members : [];
    },

    searchLabels: function(board_id) {
        return this.fields[board_id] ? this.fields[board_id].labels : [];
    },

    renderBoards: function() {
        var html = '';

        html += '<div class="field-label">Board <i class="fas fa-asterisk"></i></div>';

        if (this.boards) {
            var board_items = '';
            var board_selected = this.searchBoard(this.board_id);

            this.boards.forEach(function(board) {
                board_items += '<li data-id="' + board.id + '"' + (this.board_id === board.id ? ' class="selected"' : '') + '>' +
                                    Util.htmlEntities(board.name) +
                                '</li>';
            }.bind(this));

            if (!board_items) {
                board_items = '<li>No boards</li>';
            }

            html += '<div class="button-dropdown button-dropdown-full button-dropdown-left dropdown-board">' +
                        (board_selected ?
                        '<button type="button" class="dropdown-select"><i class="fab fa-trello" style="color:#026AA7;"></i> ' + Util.htmlEntities(board_selected.name) + '</button>' :
                        '<button type="button" class="dropdown-select"><span class="placeholder-text">No boards selected</span></button>') +
                        '<div>' +
                            '<div class="dropdown-search">' +
                                '<input type="text" class="solid compact" placeholder="Search by board name">' +
                            '</div>' +
                            '<ul class="dropdown dropdown-select">' + board_items + '</ul>' +
                        '</div>' +
                    '</div>';
        } else {
            html += '<div class="loader-placeholder-medium"></div>';
        }

        this.$el.find('.region-boards').html(html);
    },

    renderLists: function() {
        var html = '';

        html += '<div class="field-label">List <i class="fas fa-asterisk"></i></div>';

        if (this.fields[this.board_id]) {
            var list_selected = this.searchList(this.board_id, this.list_id);
            var list_items    = '';

            this.fields[this.board_id].lists.forEach(function(list) {
                list_items += '<li data-id="' + list.id + '"' + (this.list_id === list.id ? ' class="selected"' : '') + '>' +
                                    Util.htmlEntities(list.name) +
                                '</li>';
            }.bind(this));

            if (!list_items) {
                list_items = '<li>No lists</li>';
            }

            html += '<div class="button-dropdown button-dropdown-full button-dropdown-left dropdown-list">' +
                        (list_selected ?
                        '<button type="button" class="dropdown-select">' + Util.htmlEntities(list_selected.name) + '</button>' :
                        '<button type="button" class="dropdown-select"><span class="placeholder-text">No lists selected</span></button>') +
                        '<div>' +
                            '<div class="dropdown-search">' +
                                '<input type="text" class="solid compact" placeholder="Search by list name">' +
                            '</div>' +
                            '<ul class="dropdown dropdown-select">' + list_items + '</ul>' +
                        '</div>' +
                    '</div>';
        } else if (this.boards && this.boards.length === 0) {
            html += '<div class="button-dropdown button-dropdown-full button-dropdown-left dropdown-list">' +
                        '<button type="button" class="dropdown-select"><span class="placeholder-text">No lists selected</span></button>' +
                        '<div>' +
                            '<ul class="dropdown"><li>No lists</li></ul>' +
                        '</div>' +
                    '</div>';
        } else {
            html += '<div class="loader-placeholder-medium"></div>';
        }

        this.$el.find('.region-lists').html(html);
    },

    renderMembers: function() {
        var html = '<div class="field-label">Members</div>';

        if (this.fields[this.board_id]) {
            var members_selected = '';
            var member_items     = '';

            this.searchMembers(this.board_id).forEach(function(member) {
                if (this.members.indexOf(member.id) === -1) {
                    member_items += '<li data-id="' + member.id + '"' + (this.members.indexOf(member.id) !== -1 ? ' class="active"' : '') + '>' +
                                        Util.htmlEntities(member.fullName) +
                                    '</li>';
                }
            }.bind(this));

            if (!member_items) {
                member_items = '<li>No members</li>';
            }

            this.members.forEach(function(member_id) {
                var member = this.searchMember(this.board_id, member_id);
                members_selected += '<span class="badge-secondary-invert badge-btn">' +
                                        '<span>' + Util.htmlEntities(member.fullName) + '</span>' +
                                        '<span class="btn"><i class="far fa-times"></i></span>' +
                                        '<input type="checkbox" name="members" value="' + member.id + '" checked>' +
                                    '</span>';
            }.bind(this));

            html += '<div class="button-dropdown button-dropdown-full button-dropdown-left dropdown-member" data-append="true">' +
                        '<button type="button" class="dropdown-select dropdown-select-multiple">' + (members_selected || '<span class="placeholder-text">No members selected</span>') + '</button>' +
                        '<div>' +
                            '<div class="dropdown-search">' +
                                '<input type="text" class="solid compact" placeholder="Search by member name">' +
                            '</div>' +
                            '<ul class="dropdown">' + member_items + '</ul>' +
                        '</div>' +
                    '</div>';
        } else {
            html += '<div class="loader-placeholder-medium margin-bottom-20"></div>';
        }

        this.$el.find('.region-members').html(html);
    },

    renderLabels: function() {
        var html = '<div class="field-label">Labels</div>';

        if (this.fields[this.board_id]) {
            var labels_selected = '';
            var label_items     = '';

            this.searchLabels(this.board_id).forEach(function(label) {
                if (this.labels.indexOf(label.id) === -1) {
                    label_items += '<li data-id="' + label.id + '"' + (this.labels.indexOf(label.id) !== -1 ? ' class="active"' : '') + '>' +
                                        '<i class="fas fa-circle fa-xs" style="color:' + label.color + ';"></i>' +
                                        (Util.htmlEntities(label.name) || '(no name)') +
                                    '</li>';
                }
            }.bind(this));

            if (!label_items) {
                label_items = '<li>No labels</li>';
            }

            this.labels.forEach(function(label_id) {
                var label = this.searchLabel(this.board_id, label_id);
                labels_selected += '<span class="badge-secondary-invert badge-btn">' +
                                        '<span><i class="fas fa-circle fa-xs" style="color:' + label.color + ';"></i> ' + (Util.htmlEntities(label.name) || '(no name)') + '</span>' +
                                        '<span class="btn"><i class="far fa-times"></i></span>' +
                                        '<input type="checkbox" name="labels" value="' + label.id + '" checked>' +
                                    '</span>';
            }.bind(this));

            html += '<div class="button-dropdown button-dropdown-full button-dropdown-left dropdown-label" data-append="true">' +
                        '<button type="button" class="dropdown-select dropdown-select-multiple">' + (labels_selected || '<span class="placeholder-text">No labels selected</span>') + '</button>' +
                        '<div>' +
                            '<div class="dropdown-search">' +
                                '<input type="text" class="solid compact" placeholder="Search by label name">' +
                            '</div>' +
                            '<ul class="dropdown">' + label_items + '</ul>' +
                        '</div>' +
                    '</div>';
        } else {
            html += '<div class="loader-placeholder-medium margin-bottom-20"></div>';
        }

        this.$el.find('.region-labels').html(html);
    },

    renderError: function() {
        var html = '<div class="error-dialog padding-30">' +
                       '<div class="icon"><i class="fas fa-exclamation"></i></div>' +
                       '<h3>Authentication failed</h3>' +
                       '<p class="info">Your Trello account couldn\'t be connected.</p>' +
                       (Cache.app.isAdmin() ?
                       '<button class="reconnect primary medium">Reconnect Trello</button>' +
                       '<div class="divider-20"></div>' : '') +
                   '</div>';

        this.$el.html(html);
    },

    render: function() {
        var content = '';

        content += '<div class="progress-loader"></div>';
        content += '<div class="mask-light" style="display:none;"></div>';

        content += '<form class="form-fluid">' +
                        '<div class="modal-integration-innerscroll">' +
                            '<div class="row-50">' +
                                '<div class="region-boards"></div>' +
                                '<div class="region-lists"></div>' +
                            '</div>' +

                            (this.boards ?
                            '<div class="row">' +
                                '<div class="field-label">Title</div>' +
                                '<input type="text" name="title" maxlength="255" class="solid compact" placeholder="' + Util.htmlEntities(this.title) + '">' +
                            '</div>'  +
                            '<div class="row">' +
                                '<div class="field-label">Description</div>' +
                                '<textarea name="description" class="solid compact" rows="3"></textarea>' +
                            '</div>' +
                            '<div class="row region-members">' +
                            '</div>' +
                            '<div class="row region-labels">' +
                            '</div>' +
                            '<div class="row">' +
                                '<div class="field-label">Due Date</div>' +
                                '<input type="date" name="due_date" class="solid compact">' +
                            '</div>'

                            :

                            '<div class="loader-placeholder margin-bottom-8" style="width:100px;"></div>' +
                            '<div class="loader-placeholder-medium margin-bottom-20"></div>' +
                            '<div class="loader-placeholder margin-bottom-8" style="width:100px;"></div>' +
                            '<div class="loader-placeholder-large margin-bottom-20"></div>' +
                            '<div class="loader-placeholder margin-bottom-8" style="width:100px;"></div>' +
                            '<div class="loader-placeholder-medium margin-bottom-20"></div>' +
                            '<div class="loader-placeholder margin-bottom-8" style="width:100px;"></div>' +
                            '<div class="loader-placeholder-medium margin-bottom-20"></div>' +
                            '<div class="loader-placeholder margin-bottom-8" style="width:100px;"></div>' +
                            '<div class="loader-placeholder-medium"></div>') +
                        '</div>' +
                        '<div class="modal-integration-innerscroll-footer">' +
                            '<button type="submit" class="primary"' + (this.boards && this.boards.length ? '' : ' disabled') + '>Send</button>' +
                        '</div>' +
                    '</form>';

        this.$el.html(content);

        if (this.form_value.title) {
            Form.setData(this.$el.find('form'), {
                title: this.form_value.title
            });
        }

        if (!this.boards) {
            this.loadBoards();
        }

        if (this.boards && !this.fields[this.board_id]) {
            this.loadFields(this.board_id);
        }

        this.renderBoards();
        this.renderLists();
        this.renderMembers();
        this.renderLabels();

        return this;
    }
});

export default Trello_Send;
